export default "__VITE_ASSET__CXWh1obh__"